import { useEffect, useState } from "react";
import { MdOutlineHomeWork, MdOutlineRestaurant, MdOutlineHotel } from "react-icons/md";

const CATEGORY_ICONS = {
  Venue: MdOutlineHomeWork,
  Restaurant: MdOutlineRestaurant,
  Hotel: MdOutlineHotel,
};

/**
 * Cover image for a listing card, with a category-shaped placeholder for
 * listings that have no photo — and for the ones whose image fails to load,
 * which is why the fallback is state and not just a `src` check.
 */
const ListingThumb = ({ src, alt, category, className = "" }) => {
  const [failed, setFailed] = useState(false);
  const Icon = CATEGORY_ICONS[category] || MdOutlineHomeWork;

  // Thumbnails start on the stored S3 URL and switch to a presigned one once
  // it arrives; a failure against the first URL must not stick to the second.
  useEffect(() => setFailed(false), [src]);

  if (!src || failed) {
    return (
      <div
        className={`flex flex-col items-center justify-center gap-1 bg-gradient-to-br from-gray-50 to-gray-100 text-gray-300 ${className}`}
      >
        <Icon className="text-3xl" />
        <span className="text-[10px] font-medium uppercase tracking-wide">No image</span>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt || "Listing"}
      loading="lazy"
      onError={() => setFailed(true)}
      className={`object-cover bg-gray-100 ${className}`}
    />
  );
};

export default ListingThumb;
